import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:        '/notifications/list',
	title:       'menu.notification-list',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/notifications/list';
	},
});
